const _ = require('lodash');

function isUrl(value) {
  if (_.isNil(value)) return true;
  return /^(https?:\/\/)([^.\/:\s]+\.)([^.\/:\s]+[.\/]?)+$|^([^.\/:\s]+\.)([^.\/:\s]+[.\/]?)+$/.test(value);
}

module.exports = isUrl;
